<template>
    <div class="message-list-container" :style="'width:'+ width">
        <el-tabs @tab-click="onHandleClick" value="unread">
            <el-tab-pane label="未读消息" name="unread"></el-tab-pane>
            <el-tab-pane label="已读消息" name="read"></el-tab-pane>
            <el-tab-pane label="全部消息" name="all"></el-tab-pane>
        </el-tabs>
        <div class="search-container">
            <el-input
                    round
                    placeholder="请输入搜索内容"
                    suffix-icon="el-icon-search"
                    v-model="searchData" size="small" @input="onSearch">
            </el-input>
        </div>
        <div class="content">
            <slot></slot>
        </div>
        <div class="footer" :class="{ 'common-flex-center-between': allowPaging, 'common-text-center': !allowPaging }">
            <el-button type="text" @click="onPrevious" v-show="allowPaging">上一页</el-button>
            <el-button type="text" @click="onAllRead" v-show="!allowPaging">标记全部为已读</el-button>
            <el-button type="text" @click="onNext" v-show="allowPaging">下一页</el-button>
        </div>

    </div>
</template>

<script>
export default {
    name: "MessageList",
    data () {
        return {
            searchData: '',
            tabName: ''
        }
    },
    props: {
        width: {
            type: [String, Number],
            default: '300px'
        }
    },
    computed:{
        allowPaging(){
            return this.tabName !== 'unread'
        }
    },
    methods: {
        onHandleClick(tab, event) {
            this.tabName = tab.name
            this.$emit('tabs-change', tab.name)
        },
        onSearch () {
            this.$emit('search', this.searchData)
        },
        onPrevious () {
            this.$emit('previous')
        },
        onNext () {
            this.$emit('next')
        },
        onAllRead () {
            this.$emit('all-read')
        }
    },
    mounted() {
        this.tabName = 'unread'
        this.$emit('tabs-change', 'unread')
    }
}
</script>

<style scoped lang="scss">
.message-list-container {
    height: 100%;
    background: #FFFFFF;
    border-right: 1px solid #ECEFF1;
    position: relative;
    .search-container {
        margin-top:-10px;
        padding: 2px;
        border-bottom: 1px solid #ECEFF1;
        .el-input__inner {
            border-radius: 50%;
        }
    }
    .content{
        overflow-y: auto;
        position: absolute;
        top: 83px;
        left: 0;
        right: 0;
        bottom: 35px;
    }
    .footer {
        position: absolute;
        top: auto;
        left: 0;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        padding:  0 20px 0 10px;
        .el-button+.el-button{
            margin: 0;
        }
    }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/Messages/components/MessageList.vue"
}
</vue-filename-injector>
